import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class FilterDrawer extends UcoastEl {
	static htmlSelector = 'filter-drawer'
	mainDetails: HTMLDetailsElement
	mainSummary: HTMLElement
	mainContainer: HTMLElement
	applyButtons?: NodeListOf<HTMLButtonElement>
	subDetails?: NodeListOf<HTMLDetailsElement>
	subSummaries?: NodeListOf<HTMLElement>
	subContainers?: NodeListOf<HTMLElement>
	closeButtons: NodeListOf<HTMLButtonElement>
	overlay: HTMLButtonElement

	constructor() {
		super()
		this.mainDetails = q.rs('[data-main-details]', this)
		this.mainSummary = q.rs('[data-main-summary]', this)
		this.mainContainer = q.rs('[data-main-container]', this)
		this.applyButtons = q.ol('[data-apply-button]', this)
		this.subDetails = q.ol('[data-sub-details]', this)
		this.subSummaries = q.ol('[data-sub-summary]', this)
		this.subContainers = q.ol('[data-sub-container]', this)
		this.closeButtons = q.rl('button[data-close]', this)
		this.overlay = q.rs('button[data-overlay]', this)
		this.addEventListener('keyup', this.onKeyUp.bind(this))
		this.addEventListener('focusout', this.onFocusOut.bind(this))

		this.mainSummary.addEventListener(
			'click',
			this.onMainSummaryClick.bind(this)
		)
		this.subSummaries?.forEach((summary) =>
			summary.addEventListener('click', this.onSubSummaryClick.bind(this))
		)
		this.bindEvents()
	}

	bindEvents() {
		this.applyButtons?.forEach((button) =>
			button.addEventListener('click', this.onApplyButtonClick.bind(this))
		)
		this.closeButtons.forEach((button) =>
			button.addEventListener('click', this.onCloseButtonClick.bind(this))
		)
	}

	onKeyUp(event: KeyboardEvent) {
		if (event.code?.toUpperCase() !== 'ESCAPE') return

		const openDetailsElement = q.oClosestTarget<
			KeyboardEvent,
			HTMLDetailsElement
		>(event, 'details[open]')
		if (!openDetailsElement) return

		openDetailsElement === this.mainDetails
			? this.closeDrawer()
			: this.closeSubmenu(openDetailsElement)
	}

	onMainSummaryClick(event: MouseEvent) {
		event.preventDefault()
		if (this.mainDetails.hasAttribute('open')) {
			this.closeDrawer()
		} else {
			this.openDrawer()
		}
	}

	onSubSummaryClick(event: MouseEvent) {
		event.preventDefault()
		const details = q.rc<HTMLDetailsElement>(
			q.rClosestTarget(event, '[data-sub-summary]'),
			'details'
		)
		details.hasAttribute('open')
			? this.closeSubmenu(details)
			: this.openSubmenu(details)
	}

	openDrawer() {
		this.mainDetails.setAttribute('open', '')
		this.mainSummary.setAttribute('aria-expanded', 'true')
		window.setTimeout(() => {
			this.mainContainer.classList.add('open')
			this.overlay.classList.add('open')
			window.TsDOM.trapFocus(this.mainContainer)
		}, 1)
	}

	closeDrawer() {
		console.log('close town close pocket (dom)')
		this.mainContainer.classList.remove('open')
		this.overlay.classList.remove('open')
		window.setTimeout(() => {
			this.mainSummary.setAttribute('aria-expanded', 'false')
			this.mainDetails.removeAttribute('open')
			window.TsDOM.removeTrapFocus(this.mainSummary)
			this.subDetails?.forEach((details) => this.closeSubmenu(details, 0))
		}, 301)
	}

	openSubmenu(el: HTMLDetailsElement) {
		el.setAttribute('open', '')
		q.rs('[data-sub-summary]', el).setAttribute('aria-expanded', 'true')
		const c = q.rs('[data-sub-container]', el)
		c.style.maxHeight = `${c.scrollHeight}px`
	}

	closeSubmenu(el: HTMLDetailsElement, animationDelay = 301) {
		q.rs('[data-sub-container]', el).style.maxHeight = `0`
		q.rs('[data-sub-summary]', el).setAttribute('aria-expanded', 'false')
		window.setTimeout(() => {
			el.removeAttribute('open')
		}, animationDelay)
	}

	onApplyButtonClick(event: MouseEvent) {
		event.preventDefault()
		//this.mainSummary.click()
	}

	onCloseButtonClick(event: MouseEvent) {
		event.preventDefault()
		this.closeDrawer()
	}

	onFocusOut() {
		/*setTimeout(() => {
			console.log('document.activeElement', document.activeElement)
			if (
				this.mainDetails.hasAttribute('open') &&
				!this.mainDetails.contains(document.activeElement)
			)
				this.closeDrawer()
		})*/
	}
}
